import { useEffect, useState } from 'react';
import { OAuthConnection } from '../../services/RepositoryService';
import { CONNECTION_STORAGE_KEY, readStoredConnectionSelection } from './helpers';
import { ProviderTab } from './types';

export interface ConnectionSelection {
  selectedConnectionIds: Record<ProviderTab, string | null>;
  updateConnectionSelection: (provider: ProviderTab, connectionId: string | null) => void;
}

export function useConnectionSelection(connections: OAuthConnection[]): ConnectionSelection {
  const [selectedConnectionIds, setSelectedConnectionIds] = useState<
    Record<ProviderTab, string | null>
  >(readStoredConnectionSelection);

  const updateConnectionSelection = (provider: ProviderTab, connectionId: string | null) => {
    setSelectedConnectionIds((prev) => {
      const next = { ...prev, [provider]: connectionId };
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(CONNECTION_STORAGE_KEY, JSON.stringify(next));
      }
      return next;
    });
  };

  useEffect(() => {
    setSelectedConnectionIds((prev) => {
      const next = { ...prev };
      let changed = false;

      (['github', 'gitlab'] as ProviderTab[]).forEach((provider) => {
        const providerConns = connections.filter((conn) => conn.provider === provider);
        const currentSelection = prev[provider];
        if (!providerConns.find((conn) => conn.id === currentSelection)) {
          next[provider] = providerConns[0]?.id ?? null;
          changed = true;
        }
      });

      if (changed && typeof window !== 'undefined') {
        window.localStorage.setItem(CONNECTION_STORAGE_KEY, JSON.stringify(next));
        return next;
      }
      return prev;
    });
  }, [connections]);

  return { selectedConnectionIds, updateConnectionSelection };
}
